import script from "./MediaflowLiveLayer.vue?vue&type=script&setup=true&lang=js"
export * from "./MediaflowLiveLayer.vue?vue&type=script&setup=true&lang=js"

import "./MediaflowLiveLayer.vue?vue&type=style&index=0&id=a9ae8b12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a9ae8b12"]])

export default __exports__